import React from 'react';
import { Hero } from '../components/Hero';
import { FeaturedEpisodes } from '../components/FeaturedEpisodes';
import { FoundersCarousel } from '../components/FoundersCarousel';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <main className="min-h-screen bg-archival-cream text-charcoal-900 selection:bg-gold/30 selection:text-charcoal-900" data-id="element-178">
      <div className="film-grain" aria-hidden="true" data-id="element-179" />

      <Hero data-id="element-180" />
      <FeaturedEpisodes data-id="element-181" />
      <FoundersCarousel data-id="element-182" />
      <Footer data-id="element-183" />
    </main>;
}